<template>
    <div class="result-box">
       <div class="share-txt pos" @click="shareClick">叫朋友来挑战</div>
       <div class="img-box">
           <div class="img-item" v-if="item.show === result" v-for="(item,index) in resultImgList" :key="index">
                <img class="result-img" :src="item.imgUrl" alt="">
                <img class="result-img2" :class="
                    [item.show === 'hot' ? 'hotStyle' : '',
                    item.show === 'bing' ? 'bingStyle' : '',
                    item.show === 'air' ? 'airStyle' : '',
                    item.show === 'san' ? 'sanStyle':'',]"
                    :src="item.imgUrl2" alt="">
                <img class="txtUrl pos" :src="item.txtUrl" alt="">
                <p class="des pos">{{item.des}}</p>
           </div>
           <img class="user-phote pos" :src="userInfo.portraitUrl" alt="">
           <p class="nickname pos">{{userInfo.nickName}}</p>
           <p class="game-txt pos">有 <span>{{gameNum}}</span> 次抽奖机会 正确越多机会越多哦!</p>
           <div @click="savePic" class="save-pic pos">*长按保存图片</div>
           <img @click="toLottery" class="lottery-btn pos" src="../assets/img/lotteyr_btn.png" alt="">
           <img @click="toAgain" class="again-btn pos" src="../assets/img/again_btn.png" alt="">
       </div>
       <img :src="this.base64" class="img-template">
       <div class="save-img-box" ref="imgTemplate" :key="index" v-if="item.show == result" v-for="(item,index) in shareImgList" :style="{
                backgroundImage: `url(${item.imgUrl})`,
                'background-size': 'center center'
            }">
            <!-- <div :key="index" v-for="(item,index) in shareImgList">
                <img class="save-bg" v-if="item.show === result"  :src="item.imgUrl" alt="">
            </div> -->
            <div class="user-info pos">
                <img class="user-photo" :src="userInfo.portraitUrl">
                <p class="nickname pos">{{userInfo.nickName}}</p>
            </div>
            <div class="erweima">
                <img :src="erweicode" alt="">
            </div>
        </div>
        <transition name="fade">
            <div class="mask" @click="showMask = !showMask" v-show="showMask"></div>
        </transition>
        <!--toast-->
        <div class="toast" v-show="toastShow">
            {{toastText}}
        </div>
    </div>
</template>

<script>
import html2canvas from 'html2canvas';
import resultList from '../assets/js/resultPic';

export default {
    data() {
        return {
            resultImgList: resultList.resultImgList,
            shareImgList: resultList.shareImgList,
            base64: '',
            showMask: false,
            toastShow: false,
            toastText: '',
            erweicode: require('../assets/img/default.png'),
            rightTestNum: this.$store.state.summerprize.testRightNum || 0
        };
    },
    mounted() {
        html2canvas(this.$refs.imgTemplate[0], {
            scale: 1,
            logging: false,
            useCORS: true
        }).then(c => {
            this.base64 = c.toDataURL('image/png', 1);
        });
        switch (this.$route.params.source) {
            case 'tuiguang1':
                this.erweicode = require('../assets/img/tuiguang1.png');
                break;
            case 'tuiguang2':
                this.erweicode = require('../assets/img/tuiguang2.png');
                break;
            default:
                this.erweicode = require('../assets/img/default.png');
                break;
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.system.userInfo || {};
        },
        result() {
            let showFlag = null;
            if (this.rightTestNum >= 0 && this.rightTestNum <= 1) {
                showFlag = 'bing';
            }
            else if (this.rightTestNum >= 2 && this.rightTestNum <= 3) {
                showFlag = 'hot';
            }
            else if (this.rightTestNum >= 4 && this.rightTestNum <= 5) {
                showFlag = 'san';
            }
            else if (this.rightTestNum === 6) {
                showFlag = 'air';
            }
            return showFlag;
        },
        gameNum() {
            return this.$store.state.summerprize.gameNum || 0;
        }
    },
    methods: {
        toAgain() {
            /* eslint-disable-next-line */
            window._hmt.push(['_trackEvent', '市场夏日抽奖活动-再测一次', '夏日抽奖活动-再测一次点击量 ', window.location.href]);
            this.$emit('next', 2);
        },
        toLottery() {
            this.$router.push({
                path: '/circleprize',
                name: 'circleprize'
            });
            this.tongji('市场夏日抽奖活动-马上抽奖', '夏日抽奖活动-马上抽奖点击量');
        },
        // 长按保存
        savePic() {
            this.tongji('市场夏日抽奖活动-长按保存', '夏日抽奖活动-长按保存点击量');
        },
        shareClick() {
            this.showMask = true;
            this.tongji('市场夏日抽奖活动-分享', '夏日抽奖活动-分享点击量');
        },
        // 警示弹框
        toast(str) {
            this.toastText = str;
            this.toastShow = true;
            setTimeout(() => {
                this.toastShow = false;
            }, 1000);
        },
        tongji(txt1, txt2) {
            switch (this.$route.params.source) {
                case 'tuiguang1':
                    // eslint-disable-next-line
                    window._hmt.push(['_trackEvent', txt1, `tuiguang1${txt2}`, window.location.href]);
                    break;
                case 'tuiguang2':
                    // eslint-disable-next-line
                    window._hmt.push(['_trackEvent', txt1, `tuiguang2${txt2}`, window.location.href]);
                    break;
                default:
                    // eslint-disable-next-line
                    window._hmt.push(['_trackEvent', txt1, `default${txt2}`, window.location.href]);
                    break;
            }
        }
    }
};
</script>

<style lang="stylus" scoped>
@font-face
    font-family 'happy'
    src:url('/font/happy.ttf') format('truetype')
.result-box
    width 100%
    height 100%
    .share-txt
        top 0
        font-size 0.26rem
        width 100%
        height 0.5rem
        line-height 0.5rem
        text-decoration underline
        text-align center
        z-index 999
        padding-left 2.5rem
    .img-box
        width 100%
        height 100%
        .img-item
            position relative
            width 100%
            height 100%
            .result-img
                width 100%
                height 100%
            .result-img2
                position absolute
            .hotStyle
                top 6%
                left 5%
            .bingStyle
                left 7%
                top 10.5%
            .airStyle
                left 0
                top 14%
            .sanStyle
                top 16%
                left 0
            .txtUrl
                top 6%
                right 10%
            .des
                width 1px
                word-break break-word
                font-size 0.26rem
                color #5d5149
                font-family happy !important
                top 14%
                right 31.5%
        .user-phote
            top 6%
            right 24%
            width 0.87rem
            height 0.84rem
        .nickname
            width 2rem
            font-size 0.26rem
            top 6%
            right 38%
            text-align right
        .game-txt
            width 100%
            height 0.8rem
            line-height 0.8rem
            background #e5f9f7
            bottom 6%
            font-size 0.3rem
            color #5d5349
            text-align center
            span
                color #f66
                font-weight bold
        .lottery-btn
            bottom 15%
            left 10%
            z-index 999
        .again-btn
            bottom 15%
            right 10%
            z-index 999
        .save-pic
            font-family happy !important
            font-size 0.26rem
            color #5d5149
            bottom 24%
            right 33%
    .save-img-box
        size 750px 1334px
        position fixed
        top 100rem
        left 0
        .user-info
            top 4%
            right 22%
            width 0.87rem
            height 0.84rem
            z-index 1000
            img
                float left
                width 100%
                height 100%
            .nickname
                width 2rem
                right 1.2rem
                text-align right
                font-size 0.26rem
        .erweima
            position absolute
            bottom 0rem
            right 1.2rem
            z-index 999
            img
                size 92px
    .img-template
        size 100%
        position fixed
        top 0
        left 0
        z-index 100
        opacity 0
    .mask
        size 100%
        position fixed
        top 0
        z-index 2000
        background rgba(0,0,0,.8) url('../assets/img/share_tip.png') 94% 4%/1.84rem 1.71rem no-repeat
.toast
    position fixed
    z-index 2000
    left 50%
    top 50%
    transition all .5s
    text-align center
    border-radius 5px
    color #FFF
    font-size 0.28rem
    background rgba(17, 17, 17, 0.7)
    padding 0.15rem 0.3rem
    transform translateX(-50%) translateY(-50%)
</style>
